import { useEffect } from "react";
import { PortalPageProps } from "./stdlib-appmodels";

export const BlankPageFactory = <T,>(config:{pageTitle: string, pageMessage:string})=> (props: PortalPageProps<T>) => {
    const sd = props.setPageDetails;
    useEffect(() => sd({ title: config.pageTitle }), [])
    return (<div className="text-xl text-center text-gray-400 p-8">{config.pageMessage}</div>);
}

